enum DFWeaponBuildType {
  Budget = "Budget",
  HighEnd = "HighEnd",
}

export default DFWeaponBuildType;
